export default "__VITE_ASSET__DQJ5mPEs__"